/**
 * Get the label for the selected value, comparing to either the id or value in
 * the case of PICK_LIST and MULTIPLE_CHECKBOXES or returning the selectedValue as is
 * for other input control types.
 * @param selectedValue Either the id of the option (PICK_LIST or MULTIPLE_CHECKBOXES) or the raw value
 * @param productProperty The property definition
 */
export const getProductPropertyLabel = (selectedValue, productProperty) => {
    var _a;
    switch (productProperty.inputControlType) {
        case 'PICK_LIST':
        case 'MULTIPLE_CHECKBOXES': {
            const item = (_a = productProperty.values) === null || _a === void 0 ? void 0 : _a.find((value) => value.id.toString() === selectedValue);
            return (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.value) || selectedValue;
        }
        default: {
            return selectedValue;
        }
    }
};
export const getProductPropertyId = (propertyDefinitionId, propertyValue, product) => {
    var _a, _b;
    if (!product) {
        return { propertyDefinitionId: '', value: '' };
    }
    const propertyDetails = (_a = product === null || product === void 0 ? void 0 : product.properties) === null || _a === void 0 ? void 0 : _a.find((productProperty) => productProperty.id.toString() === propertyDefinitionId.toString());
    let value = '';
    if (propertyDetails) {
        switch (propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.inputControlType) {
            case 'PICK_LIST':
            case 'MULTIPLE_CHECKBOXES': {
                const matchingValueOption = (_b = propertyDetails.values) === null || _b === void 0 ? void 0 : _b.find((propertyDetailValue) => propertyDetailValue.id.toString() === propertyValue.toString());
                if (matchingValueOption) {
                    value = matchingValueOption.id.toString();
                }
                break;
            }
            default: {
                value = propertyValue !== null && propertyValue !== void 0 ? propertyValue : '';
            }
        }
    }
    return {
        propertyDefinitionId: propertyDefinitionId.toString(),
        value,
    };
};
